export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20amber%20light%20streaks%20against%20deep%20charcoal%20background%2C%20abstract%20film%20grain%20texture%2C%20soft%20bokeh%20lights%2C%20elegant%20movie%20theater%20ambiance%2C%20no%20people%2C%20artistic%20and%20moody%20composition%20with%20rich%20contrast%2C%20luxurious%20cinema%20aesthetic&width=1800&height=900&seq=hero-bg-2026-mushroom&orientation=landscape"
          alt="蘑菇影院高清影视背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 rounded-full mb-5 whitespace-nowrap">
              每日更新 · 海量高清
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 text-balance">
              蘑菇影院 - 高清电影电视剧免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-background-200 font-heading font-medium mb-6">
              追剧不卡顿，沉浸式观影体验
            </p>

            <p className="text-sm md:text-base text-background-300 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              蘑菇影院汇聚海量高清电影在线资源和电视剧全集，涵盖动作、喜剧、爱情、悬疑、科幻等多元类型，每日更新最新高清电影与热门剧集。
              本站支持流畅高清播放，无需下载即可免费在线观看，致力于为您打造沉浸式追剧体验。无论是最新院线大片还是经典高分剧集，都能在这里找到。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">20000+</div>
                <div className="text-xs text-background-400 mt-1">海量片库</div>
              </div>
              <div className="w-px h-10 bg-background-700 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1080P</div>
                <div className="text-xs text-background-400 mt-1">高清画质</div>
              </div>
              <div className="w-px h-10 bg-background-700 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">极速</div>
                <div className="text-xs text-background-400 mt-1">流畅播放</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                开始观看
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold border border-background-400/50 text-background-200 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20warm%20golden%20spotlight%20composition%20on%20dark%20stage%2C%20elegant%20theater%20curtains%20in%20deep%20crimson%20red%2C%20soft%20dramatic%20lighting%2C%20movie%20premiere%20atmosphere%2C%20luxurious%20and%20artistic%2C%20no%20text%2C%20no%20people%2C%20rich%20contrast%20with%20warm%20amber%20highlights&width=800&height=600&seq=hero-visual-mushroom-cinema&orientation=landscape"
                alt="蘑菇影院高清观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
            <div className="absolute -bottom-3 -right-3 w-24 h-24 md:w-28 md:h-28 bg-accent-500/20 rounded-2xl -z-10 hidden lg:block"></div>
            <div className="absolute -top-3 -left-3 w-20 h-20 md:w-24 md:h-24 bg-primary-500/10 rounded-2xl -z-10 hidden lg:block"></div>
          </div>
        </div>
      </div>
    </section>
  );
}